const defaults = {
    APP_URL: process.env.REACT_APP_URL,
    GA_ID: process.env.REACT_APP_GA_ID,
    API_ID: process.env.REACT_APP_SPACE_ID,
    API_TOKEN: process.env.REACT_APP_API_TOKEN,
    API_URL: `${process.env.REACT_APP_API_URL}/spaces/${
        process.env.REACT_APP_SPACE_ID
    }`
};

export const getConfig = name => defaults[name];



// WEBPACK FOOTER //
// ./src/config.js